"use client";

/**
 * LocationPriceCaption — renders a "Price for <location>" caption below the
 * PDP price block when the active location carries a non-zero discount.
 *
 * This is a leaf client component intentionally kept minimal so it can be
 * dropped into the server-rendered VariantBlock without converting the entire
 * PDP to a client component.
 *
 * Visibility rules:
 *  - Hidden when no location is active (anonymous / no default set).
 *  - Hidden when `discount_percent === 0` (location has no override).
 *  - Visible otherwise: shows "Price for <name>" in ink-500 caption style.
 */

import { useActiveLocation } from "../src/hooks/useActiveLocation";

export function LocationPriceCaption() {
  const activeLoc = useActiveLocation();

  if (!activeLoc || activeLoc.discount_percent === 0) return null;

  return (
    <p className="text-xs text-ink-500">
      Price for {activeLoc.name}
    </p>
  );
}
